import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-8 gap-4" }
const _hoisted_3 = { class: "w-16 h-16 bg-sky text-white flex items-center justify-center rounded-md hidden md:flex flex-shrink-0" }
const _hoisted_4 = { class: "md:pl-5" }
const _hoisted_5 = { class: "text-xs md:text-sm leading-4 md:leading-5 font-medium mb-1 text-gray-500" }
const _hoisted_6 = { class: "text-xl md:text-2xl leading-8 font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "bg-white shadow-sm rounded-lg col-span-9 divide-y mt-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 md:px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl md:leading-8 font-bold" }, "Loan requests")
], -1)
const _hoisted_9 = { class: "md:w-2/3" }
const _hoisted_10 = { class: "text-sm leading-5 font-medium text-sky mb-1 md:mb-2" }
const _hoisted_11 = { class: "text-xs md:text-sm leading-5 font-normal text-gray-500 flex items-start md:items-center" }
const _hoisted_12 = { class: "md:w-1/3 flex md:flex-col md:items-end justify-between md:justify-start pt-3 md:pt-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "|", -1)
const _hoisted_14 = { class: "inline-flex items-center leading-5 font-medium text-sky text-xs mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationMarkerIcon = _resolveComponent("LocationMarkerIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, ({ title, subtitle, icon }, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "bg-white rounded-lg col-span-4 lg:col-span-2 shadow-sm flex items-center p-4 md:p-6",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(icon), { class: "w-6 h-6" }))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h4", _hoisted_5, _toDisplayString(title), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(subtitle), 1)
              ])
            ]))
          }), 128))
        ]),
        (_ctx.distributions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributions, ({ distributionDashboardOfferingMemorandum, status, modifiedDate }, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "py-4 px-4 md:px-6 block md:flex justify-between items-center",
                  key: index,
                  to: `/offering-memorandum/${distributionDashboardOfferingMemorandum.id}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h5", _hoisted_10, _toDisplayString(distributionDashboardOfferingMemorandum.headline), 1),
                      _createElementVNode("p", _hoisted_11, [
                        _createVNode(_component_LocationMarkerIcon, { class: "w-3 h-3 md:w-4 md:h-4 mr-1 mt-1 md:mt-0 flex-shrink-0" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.getAddress(distributionDashboardOfferingMemorandum.address)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["py-1 px-3 flex justify-center items-center text-xs rounded-full", {
              'bg-yellow-200 text-yellow-700': status == 'Quoted',
              'bg-gray-100 text-gray-700': status == 'Viewed' || _ctx.statusMap[status] == 'Received',
              'bg-red-100 text-red-700': status == 'NotInterested',
              'bg-green-100 text-green-700': status == false
            }])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getDate(modifiedDate)), 1),
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.statusMap[status]), 1)
                      ], 2),
                      _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(" Open details "),
                        _createVNode(_component_ArrowRightIcon, { class: "w-4 h-3 ml-1" })
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}